import SiteSearchGroup from '@/components/search-group'
import { mailManuscript } from '@/api/mail'
import { editorManuscript } from '@/api/editor'
import { ARTICLE_STATUS } from '@/utils/dict'
import { EMAILSTATUS, EMAILEVENT } from '@/utils/dict'
import help from '@/utils/help'
// import Detail from './detail.dialog'
import Detail from '../../../system/manage-email/communication-records/detail.dialog'
const columns = [
  {
    title: '',
    enTitle: 'Correspondence Time',
    width: 170,
    dataIndex: 'sendTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Letter Subject',
    width: 360,
    dataIndex: 'subject',
    slot: 'title'
  },
  {
    title: '',
    enTitle: 'Recipient',
    width: 200,
    dataIndex: 'toMail',
    slot: 'emails'
  },
  {
    title: '',
    enTitle: 'Email Event',
    width: 150,
    dataIndex: 'eventName'
    // slot: 'event'
  },
  // {
  //   title: '',
  //   enTitle: 'Revision',
  //   width: 100,
  //   dataIndex: 'sign'
  // },
  {
    title: '',
    enTitle: 'Operator',
    width: 150,
    dataIndex: 'operator',
    slot: 'name'
  }
]
export default {
  components: {
    SiteSearchGroup,
    Detail
  },
  data() {
    return {
      columns,
      ARTICLE_STATUS,
      EMAILSTATUS,
      EMAILEVENT,
      showAdv: false,
      articleDetail: {},
      sendTimeStart: '',
      params: {
        sign: 1
      },
      date: [],
      dataSource: [],
      show: false,
      inputData: {},
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.getQuery()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery() {
      this.articleDetail = await editorManuscript.query(this.id)
      // mock
      // this.articleDetail = articleDetail
      this.params.sign = this.articleDetail.sign
      this.getList()
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const { list, pageIndex, pageSize, total } = await mailManuscript.record(
        this.id,
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleDateChange(date) {
      this.params.sendTimeStart = date[0] ? date[0].startOf('d') : ''
      this.params.sendTimeEnd = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    handleClear() {
      this.params.keyword = ''
      this.params.subject = ''
      this.date = []
      this.getList()
    },
    openRecord(val) {
      this.inputData = val
      this.show = true
    },
    cancel() {
      this.show = false
    },
    onSignChange(val) {
      this.params.sign = val
      this.getList()
    }
  }
}
